import Availability from "app/models/availability"
import { Action, Types } from "./templateWeekAvailabilities.actions"

export type TemplateWeekAvailabilityState = {
  errors: {}
  loading: boolean
  data: Availability[]
}

const initialState: TemplateWeekAvailabilityState = {
  data: [],
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): TemplateWeekAvailabilityState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data || [],
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
